import { render } from "./GenreTabs.vue?vue&type=template&id=23c2c1ab&scoped=true"
import script from "./GenreTabs.vue?vue&type=script&lang=js"
export * from "./GenreTabs.vue?vue&type=script&lang=js"

import "./GenreTabs.vue?vue&type=style&index=0&id=23c2c1ab&scoped=true&lang=css"

import exportComponent from "/home/runner/work/somosteatro/somosteatro/ui/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-23c2c1ab"]])

export default __exports__